"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ClinicBranding/LogoCropModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _ImageCropper = require('web/components/ImageCropper'); var _ImageCropper2 = _interopRequireDefault(_ImageCropper);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _log = require('shared/log');
var _logoCrop = require('./logoCrop');

/* The crop step before a logo upload (D-27). The wide logo's box keeps the
 * logo's own shape (D-30), held between square and 8 times as wide as it is
 * tall, and starts over as much of the image as fits; the icon's and team
 * logo's box is square. In both the box resizes without changing shape, and
 * the image zooms and moves under it. Use this crop exports the
 * crop at its stored size as a PNG; Cancel uploads nothing. While the
 * export runs, the window can't be closed, and if it goes anyway (the page
 * moves on) the finished export is dropped (D-27 review F-1). */








const TITLES = {
  logo: 'Crop your logo',
  icon: 'Crop your icon',
  team: 'Crop the team logo',
}

const HINTS = {
  logo: "The box keeps your logo's shape. Drag or zoom to choose the area.",
  icon: 'Drag the image and zoom to fit your mark in the square.',
  team: 'Drag the image and zoom to fit the logo in the square.',
}

const LogoCropModal = ({ file, kind, onCropped, onCancel }) => {
  const [error, setError] = _react.useState(null)
  const [isExporting, setIsExporting] = _react.useState.call(void 0, false)
  const isWide = kind === 'logo'
  // False once the window is cancelled or gone: a late export is dropped.
  const isActiveRef = _react.useRef.call(void 0, true)
  _react.useEffect.call(void 0, () => {
    isActiveRef.current = true
    return () => { isActiveRef.current = false }
  }, [])

  const onConfirm = _react.useCallback.call(void 0, (cropper) => {
    setIsExporting(true)
    setError(null)
    _logoCrop.exportLogoCrop.call(void 0, cropper, kind, file.name)
      .then(result => {
        if (!isActiveRef.current) return
        if (typeof result === 'string') setError(result)
        else onCropped(result)
      })
      .catch((e) => {
        _log.log.error(e instanceof Error ? e : new Error(String(e)), { tags: { feature: 'logo-crop', kind } })
        if (isActiveRef.current) setError("The image couldn't be read")
      })
      .finally(() => { if (isActiveRef.current) setIsExporting(false) })
  }, [kind, file.name, onCropped])

  // Cancel, Esc, Close and the backdrop do nothing while the export runs.
  const close = _react.useCallback.call(void 0, () => {
    if (isExporting) return
    isActiveRef.current = false
    onCancel()
  }, [isExporting, onCancel])

  return (
    _react2.default.createElement(_Modal2.default, { isOpen: true, onClose: close, title: TITLES[kind], className: "logo-crop", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
      , _react2.default.createElement('p', { className: "logo-crop--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}},  HINTS[kind] )
      , _react2.default.createElement(_ImageCropper2.default, {
        file: file,
        onConfirm: onConfirm,
        onCancel: close,
        isSubmitting: isExporting,
        isCancelEnabled: !isExporting,
        primaryLabel: "Use this crop"  ,
        zoomable: true,
        autoCropArea: 1,
        ...(isWide ? { imageAspectRange: _logoCrop.WIDE_ASPECT_RANGE } : { aspectRatio: 1 }),
        className: _classBuilder2.default.call(void 0, 'logo-crop--cropper', kind === 'team' && 'logo-crop--cropper-round'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}

        ,  error && _react2.default.createElement('p', { className: "logo-crop--error", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}},  error ) 
      )
    )
  )
}

exports. default = LogoCropModal
